import corporateTransportationSubmission from "./corporateTransportationSubmission.component";
import corporateTransportationSubmissionUrls from "./corporateTransportationSubmission.urls";
import CorporateTransportationSubmissionTransforms from "./corporateTransportationSubmission.transforms";

const corporateTransportationSubmissionModule = angular
  .module("app.components.corporateTransportationSubmission", [])
  .component(
    "corporateTransportationSubmissionPage",
    corporateTransportationSubmission
  )
  .service(
    "CorporateTransportationSubmissionTransforms",
    CorporateTransportationSubmissionTransforms
  )
  .config(corporateTransportationSubmissionUrls);

export default corporateTransportationSubmissionModule;



// WEBPACK FOOTER //
// ./src/pages/corporateTransportationSubmission/corporateTransportationSubmission.module.js